import React, { useState, useContext } from 'react';
import { FirebaseContext } from '../../context/firebase';
import { Link } from 'react-router-dom';
import { Paper, TextField } from '@material-ui/core';
import styles from './PasswordReset.module.scss';
import CustomButton from '../layout/customButton/CustomButton';
import { proceedLogOut } from '../../redux/auth/actions';
import { getProfileSuccess } from '../../redux/profile/action';
import { signInSuccess } from '../../redux/signIn/actions';
import { setRedirect } from '../../redux/signIn/actions';
import { connect } from 'react-redux';

const redirectUrl = window.location.origin + '/signin'; // 🚩Need to update firebase console

function PasswordReset(props) {
	const { proceedLogOut, getProfileSuccess, signInSuccess, setRedirect } =
		props;
	const { firebase } = useContext(FirebaseContext);
	const [formData, setFormData] = useState({
		email: '',
	});

	const { email, password } = formData;
	const [success, setSuccess] = useState('');
	const [error, setError] = useState('');

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const handleSignin = (e) => {
		e.preventDefault();
		setError();
		setSuccess();

		//firebase
		if (formData.email === '') {
			setError('Please enter an email.');
		} else {
			firebase
				.auth()
				.sendPasswordResetEmail(email, {
					url: redirectUrl,
				})
				.then(() => {
					setSuccess('Email sent.');
					setTimeout(() => {
						setSuccess('');
					}, 3000);
				})
				.catch((error) => {
					setFormData({ email: '' });
					setError(error.message);
					if (error.code === 'auth/invalid-email') {
						setError(
							"Don't see that email, try again? Forgot Password"
						);
					}
				});
		}
	};

	const handleBackToLogIn = () => {
		proceedLogOut();
		getProfileSuccess({
			profileInfo: {},
		});
		localStorage.clear();
		signInSuccess({
			userInfo: {
				displayName: '',
				email: '',
				phoneNumber: '',
				photoURL: '',
				uid: '',
			},
			userType: '',
		});
		setRedirect(false);
	};

	return (
		<>
			<div className={styles.password_reset_form}>
				<Paper
					className={styles.wrapper}
					style={success || error ? { maxHeight: '430px' } : null}
				>
					{success && <p className='form-success'>{success}</p>}
					{error && <p className='form-error'>{error}</p>}
					<form
						className={styles.form}
						onSubmit={handleSignin}
						method='POST'
					>
						<p className={styles.header_title}>Reset Password</p>
						<p className={styles.header_text}>
							Enter your email address below and we’ll send you a
							link to reset your password
						</p>
						<div className={styles.form_group}>
							<TextField
								type='email'
								label='Email Address'
								className={styles.email_field}
								name='email'
								value={email}
								onChange={(e) => onChange(e)}
								variant='outlined'
								required
							/>
						</div>

						<CustomButton width={345} height={42} type='submit'>
							Send email
						</CustomButton>
						<button
							className={styles.back_btn}
							type='button'
							onClick={handleBackToLogIn}
						>
							Back to Log in
						</button>
						<small
							id='send-again'
							className={styles.success_msg}
						></small>
					</form>
				</Paper>
			</div>
		</>
	);
}

export default connect(null, {
	signInSuccess,
	setRedirect,
	proceedLogOut,
	getProfileSuccess,
})(PasswordReset);
